import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Experience, ExperienceType } from "@domain/experience/experience";
import { Organization } from "@domain/organization/organization";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap } from "@ui/styles/utils";
import { ExperienceEditor } from "./experienceEditor";

interface ExperienceEditionModalProps extends React.HTMLAttributes<HTMLDivElement> {
	experience?: Experience;
	type: ExperienceType;
	close: () => void;
}

export const ExperienceEditionModal: React.FC<ExperienceEditionModalProps> = ({
	experience,
	type,
	close,
	...htmlProps
}) => {
	return (
		<Container
			{...htmlProps}
			close={close}
			title={I18n.t(experience ? "experience.edit.title" : `experience.${type.toLowerCase()}.create.title`)}
			keyboardEventDisabled
		>
			<ExperienceEditor
				experienceId={experience?.id}
				onSave={close}
				initialOrganization={experience?.organization.id ? (experience.organization as Organization) : undefined}
				initialExperience={
					experience
						? {
								...experience,
								organizationId: experience.organization.id,
								organizationName: experience.organization.primaryName,
							}
						: {
								start: new Date(),
								title: "",
								type: type,
								organizationName: "",
							}
				}
			/>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${gap(35)}
`;
